// PageOneBody.js
import styled from 'styled-components';

const DepositCss = styled.body`
   overflow: auto !important;
  /* other styles for page one */
`;

export default DepositCss;
